module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/jobber-selection/2-bacc740d54132960bd5e1f0a79b78d4b.svg";